import { EndpointSetting } from "@/constants/app/type";
import { VoucherState } from "../type";
import { getCookie } from "@/utils/app/storage";
import { normalizeVoucherCodesValidateResponse } from "@/utils/voucher/normalizeVoucherCodesValidate";

export const callbackVoucherValidate: EndpointSetting["caller"] = (
  state: VoucherState,
  action: any,
  endpointName: any
) => {
  const normalized = normalizeVoucherCodesValidateResponse(action.payload)
  state.voucher_validate.loading = false
  state.voucher_validate.error = null
  state.voucher_validate.success = true
  state.voucher_validate.data = normalized
  if (!normalized?.valid || !normalized?.voucher) return

  const v = normalized.voucher
  const code = v.voucherCode
  const inGetAll = state.voucher_get_all.data.some((x) => x.voucherCode === code)
  const inCustomer = state.voucher_customer_get_all.data.some((x) => x.voucherCode === code)
  if (inGetAll || inCustomer) return

  if (getCookie("token")) {
    state.voucher_customer_get_all.data.unshift(v)
  }
  if (!state.voucher_get_all.data.some((x) => x.voucherCode === code)) {
    state.voucher_get_all.data.unshift(v)
  }
  if (!state.sessionInjectedVoucherCodes.includes(code)) {
    state.sessionInjectedVoucherCodes.push(code)
  }
};
